import { Images } from '@/assets/images';
import { REGEX } from '@/constant';
import { dayjs, formatDate, insertObjectIf } from '@/utils';

import { isNotNilOrEmpty } from 'ramda-adjunct';

import { FormConfig } from '../define-document-write.type';

const initializeValue = {
	foodAccomDeductionEmployer: '',
	foodAccomDeductionWorker: '',
	foodAccomDeductionEmployerEn: '',
	foodAccomDeductionWorkerEn: '',
	foodAccomDeductionMonthlyWage: '2156880',
	// foodAccomDeductionMonthlyWageYearly: '',
	foodAccomDeductionTotal: '430000',
	// foodAccomDeductionTotalYearly: '',
	foodAccomDeductionRegistDate: '',
	foodAccomDeductionRegistName: '',
	foodAccomDeductionSignature: '',
};

type IValues = typeof initializeValue;

export const DEDUCTION_AGREEMENT_CONFIG: FormConfig<IValues> = {
	initializeValue,
	title: '숙식비 공제 동의서',
	mapPropToValues({ applicantData, franchiseData }) {
		return {
			...insertObjectIf(isNotNilOrEmpty(applicantData), {
				foodAccomDeductionWorker: applicantData?.fullName,
				foodAccomDeductionWorkerEn: applicantData?.fullName,
				foodAccomDeductionRegistName: applicantData?.fullName,
			}),
			...insertObjectIf(isNotNilOrEmpty(franchiseData), {
				foodAccomDeductionEmployer: franchiseData?.employerName,
				foodAccomDeductionEmployerEn: franchiseData?.employerName,
			}),
			foodAccomDeductionRegistDate: formatDate(dayjs()),
		};
	},
	pages: [
		{
			background: {
				src: Images.deductionAgreement,
				className: 'template',
				dataSource: Images.deductionAgreement,
			},
			textAreas: [
				{
					name: 'foodAccomDeductionEmployer',
					maxHeight: 36,
					maxLength: 10,
					className: 'text-center text-[17.33px] leading-none',
					containerClassName:
						'absolute top-[152px] left-[142px] w-[147px] items-end',
				},
				{
					name: 'foodAccomDeductionWorker',
					maxHeight: 36,
					maxLength: 35,
					className: 'text-center text-[12px]',
					containerClassName:
						'absolute top-[152px] left-[459px] w-[186px] items-end',
				},
				{
					name: 'foodAccomDeductionEmployerEn',
					maxHeight: 36,
					maxLength: 10,
					className: 'text-center text-[17.33px] leading-none',
					containerClassName:
						'absolute top-[233px] left-[349px] w-[123px] items-end',
				},
				{
					name: 'foodAccomDeductionWorkerEn',
					maxHeight: 36,
					maxLength: 35,
					className: 'text-center text-[12px]',
					containerClassName:
						'absolute top-[259px] left-[85px] w-[308px] items-end',
				},
				{
					name: 'foodAccomDeductionMonthlyWage',
					maxHeight: 24,
					maxLength: 10,
					className: 'text-center text-[15px]',
					containerClassName: 'absolute top-[419px] left-[198px] w-[110px]',
					regex: REGEX.ALLOW_NUMBER_SPECIAL_CHARS,
					currency: true,
				},
				{
					name: 'foodAccomDeductionMonthlyWage',
					maxHeight: 24,
					maxLength: 10,
					className: 'text-center text-[15px]',
					containerClassName: 'absolute top-[452px] left-[245px] w-[125px]',
					regex: REGEX.ALLOW_NUMBER_SPECIAL_CHARS,
					currency: true,
				},
				// {
				// 	name: 'foodAccomDeductionMonthlyWageYearly',
				// 	maxHeight: 24,
				// 	maxLength: 20,
				// 	className: 'text-[15px]',
				// 	containerClassName: 'absolute top-[420px] left-[370px] w-[200px]',
				// 	disabled: true,
				// },
				{
					name: 'foodAccomDeductionTotal',
					maxHeight: 24,
					maxLength: 10,
					className: 'text-center text-[15px]',
					containerClassName: 'absolute top-[491px] left-[250px] w-[97px]',
					regex: REGEX.ALLOW_NUMBER,
					currency: true,
				},
				// {
				// 	name: 'foodAccomDeductionTotalYearly',
				// 	maxHeight: 24,
				// 	maxLength: 20,
				// 	className: 'text-[15px]',
				// 	containerClassName: 'absolute top-[491px] left-[403px] w-[200px]',
				// 	disabled: true,
				// },
				{
					name: 'foodAccomDeductionTotal',
					maxHeight: 24,
					maxLength: 10,
					className: 'text-center text-[15px]',
					containerClassName: 'absolute top-[522px] left-[529px] w-[87px]',
					regex: REGEX.ALLOW_NUMBER,
					currency: true,
				},
				{
					name: 'foodAccomDeductionRegistName',
					maxHeight: 30,
					maxLength: 25,
					className: 'text-center text-[12px] leading-[12px]',
					containerClassName:
						'absolute w-[130px] h-[36px] top-[870px] left-[383px]',
				},
			],
			datePickers: [
				{
					name: 'foodAccomDeductionRegistDate',
					className:
						'text-center w-[255px] [&>.ant-picker-input>input]:!text-[14px]',
					format: 'YYYY-MM-DD',
					containerClassName: 'absolute top-[800px] left-[313px]',
					style: {
						fontSize: '14px',
					},
				},
			],
			signatures: [
				{
					name: 'foodAccomDeductionSignature',
					className: 'absolute w-[90px] h-[36px] top-[863px] left-[517px]',
				},
			],
			highlightBoxes: [
				{
					name: 'foodAccomDeductionEmployer',
					className: 'w-[145px] top-[165px] left-[143px]',
				},
				{
					name: 'foodAccomDeductionWorker',
					className: 'w-[191px] top-[165px] left-[460px]',
				},
				{
					name: 'foodAccomDeductionEmployerEn',
					className: 'w-[121px] top-[246px] left-[350px]',
				},
				{
					name: 'foodAccomDeductionWorker',
					className: 'w-[309px] top-[271px] left-[86px]',
				},
				{
					name: 'foodAccomDeductionMonthlyWage',
					className: 'w-[77px] top-[420px] left-[110px]',
				},
				{
					name: 'foodAccomDeductionMonthlyWage',
					className: 'w-[126px] top-[455px] left-[115px]',
				},
				{
					name: 'foodAccomDeductionTotal',
					className: 'w-[127px] top-[492px] left-[115px]',
				},
				{
					name: 'foodAccomDeductionTotal',
					className: 'w-[374px] top-[525px] left-[115px]',
				},
				{
					name: 'foodAccomDeductionRegistDate',
					className: 'w-[40px] top-[801px] left-[247px]',
				},
				{
					name: 'foodAccomDeductionRegistName',
					className: 'w-[150px] top-[871px] left-[208px]',
				},
				{
					name: 'foodAccomDeductionSignature',
					className: 'w-[62px] top-[871px] left-[530px]',
				},
			],
		},
	],
};
